import {
  Component,
  HostListener,
  Inject
} from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';

@Component({
  selector:'app-gallery-viewer',
  templateUrl:'./gallery-viewer.component.html',
  styleUrls:['./gallery-viewer.component.scss']
})
export class GalleryViewerComponent {

  images:string[]=[];
  currentIndex=0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private dialogRef:MatDialogRef<GalleryViewerComponent>
  ){
    this.images=data.images || [];
    this.currentIndex=data.index || 0;
  }

  next():void{
    this.currentIndex=
      (this.currentIndex+1)%this.images.length;
  }

  prev():void{
    this.currentIndex=
      (this.currentIndex-1+this.images.length)%this.images.length;
  }

  close():void{
    this.dialogRef.close();
  }

  @HostListener('window:keydown.arrowright')
  onRight():void{
    this.next();
  }

  @HostListener('window:keydown.arrowleft')
  onLeft():void{
    this.prev();
  }

  @HostListener('window:keydown.escape')
  onEsc():void{
    this.close();
  }
}